import React from 'react';
import './DivCardHome.css';

const DivCardHome = () => {
  return (
    <div className="divcardshome-container">
      <div className="divcardshome-item">
        <h2 className="divcardshome-header-title">Nuestros Servicios Digitales</h2>
        <div className="divcardshome-card card-marketing">
          <div className="divcardshome-content">
            <img src="https://firebasestorage.googleapis.com/v0/b/app-cleaning-9c173.firebasestorage.app/o/wenowsocial-images%2Fsebastian-romero-bOqnq_lcZU8-unsplash%20(1).jpg?alt=media&token=e4dd1f91-1d8d-45af-9a70-c07b8dd46b88" alt="Marketing Digital" className="divcardshome-image" />
            <div className="divcardshome-card2-submenu">
              <h2 className="divcardshome-title">Marketing Digital</h2>
              <p className="divcardshome-description">Estrategias efectivas para aumentar tu presencia online.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="divcardshome-item">
        <div className="divcardshome-card card-webdesign">
          <div className="divcardshome-content">
            <img src="https://firebasestorage.googleapis.com/v0/b/app-cleaning-9c173.firebasestorage.app/o/wenowsocial-images%2Fsebastian-romero-chA0aRhx2nw-unsplash%20(1).jpg?alt=media&token=425a5485-6718-4cf8-ade9-8b23ecab582d" alt="Diseño Web" className="divcardshome-image" />
            <div className="divcardshome-card2-submenu">
              <h2 className="divcardshome-title">Diseño Web</h2>
              <p className="divcardshome-description">Diseños modernos y funcionales para tu sitio web y más paginas web</p>
            </div>
          </div>
        </div>
      </div>
      <div className="divcardshome-item">
        
      <h2 className="divcardshome-card2-title">Nuestros Servicios Digitales</h2>
        <div className="divcardshome-card card-automation">
          <div className="divcardshome-content">
            <img src="https://firebasestorage.googleapis.com/v0/b/app-cleaning-9c173.firebasestorage.app/o/wenowsocial-images%2Fsebastian-romero-re5XorFF0Os-unsplash%20(1).jpg?alt=media&token=6ff4a404-f35e-42b8-9a21-aa9ceadd4c33" alt="Automatización IA" className="divcardshome-image" />
            <div className="divcardshome-card2-submenu">
              <h2 className="divcardshome-title">Automatización IA</h2>
              <p className="divcardshome-description">Soluciones de inteligencia artificial para optimizar tu negocio.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DivCardHome;